import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import './Home.scss'
import logo from '../assets/images/logo.png'
import { Flex } from 'antd';
import { LazyLoadImage } from "react-lazy-load-image-component";

const Home = () => {
    const menuData = [
        { label: "网站首页", key: "/index" },
        { label: "关于我们", key: "/about" },
        { label: "企业优势", key: "/advantage" },
        { label: "样板工程", key: "/typical" },
    ]
    const [current, setCurrent] = useState('/index');
    const navigateTo = useNavigate()
    const onClick = (e) => {
        setCurrent(e.key);
        navigateTo(e.key);
        setTimeout(() => {
            calculateCssZoom();
        }, 100)
    };
    const { pathname } = useLocation()
    const [cssZoom, setCssZoom] = useState(1)
    const [cssHeight, setCssHeight] = useState(4517)

    useEffect(() => {
        setTimeout(() => {
            calculateCssZoom();
        }, 100)
        window.addEventListener('resize', calculateCssZoom);
        return () => {
            window.removeEventListener('resize', calculateCssZoom);
        };
        // setCurrent(pathname)
        /*eslint-disable */
    }, [])



    useEffect(() => {
        if (pathname === '/SecondaryPage') {
            setCurrent('/index')
        } else {
            setCurrent(pathname)
        }
    }, [pathname])

    const openPage = () => {
        window.open('https://beian.miit.gov.cn/#/Integrated/index')
    }

    const calculateCssZoom = () => {
        const domHeight: any = document.getElementById('root'); // 获取到根节点的高度
        setCssHeight(domHeight.clientHeight);
        const main: any = document.getElementById('wrap'); // 获取到根节点的高度
        main.scrollTop = 0;
        const viewportWidth: number = document.documentElement.clientWidth || document.body.clientWidth; // 实际浏览器视口的宽度
        const designWidth: number = window['layoutWith']; // 设计稿的宽度
        const zoomValueWidth = viewportWidth / designWidth; // 宽度计算出来的zoom值
        const targetZoom = zoomValueWidth; // 比较大小选择最终实际需要的zoom值
        setCssZoom(targetZoom)
    };
    // marginBottom: `-${Math.ceil(cssHeight - (cssHeight * cssZoom))}px`
    // return <div className='wrap' style={{ position: "relative", overflow: "auto", transform: `scale(${cssZoom})` }}>
    return <div className='wrap' id='wrap' >
        {/* style={{ transform: `scale(${cssZoom})` }} */}
        <header className='header'>
            <Flex className='header-content' align='center' justify='space-between'>
                <img className="logo" alt="logo" src={logo} />
                <Flex>
                    {menuData.map((it) =>
                        <div onClick={() => { onClick(it) }} className={`menuItem fs16 ${current === it.key ? 'act' : ''}`} key={it.key}>{it.label}</div>
                    )}
                </Flex>
            </Flex>
        </header>
        {/* 窗口部分 */}
        <div className='main-wrap'>
            <div className="main" style={{ position: "relative", transform: `scale(${cssZoom})` }}>
                <Outlet />
                <footer className='footer'>
                    <div className="footer-logo">
                        <div className="text tit1">
                            沐夏
                            <span>Moosa</span>
                        </div>
                        <div className="text tit2">做全球高品质系统门窗服务商</div>
                    </div>
                    <div className="info">
                        <div className="li">
                            <span>电话：</span>
                            <span>156 2220 9339</span>
                        </div>
                        <div className="li">
                            <span>地址：</span>
                            <span>广东省佛山市南海区里水镇赤山金福工业园</span>
                        </div>
                    </div>

                    <div className="wx-code">
                        <LazyLoadImage src={require(`../assets/images/wx_code.png`)}
                            effect="opacity"
                            alt={`wxcode`}
                        />
                    </div>
                </footer>
                <div className='copyright'>
                    <span onClick={openPage}>备案号：鄂ICP备2024038491号-1</span>
                </div>
            </div>

        </div>

    </div >
}
export default Home
